import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "month", "year", "teamId", "userId", 
    "startsOn", "endsOn", "dateInputsContainer",
    "helperText", "inheritedMessage", 
    "inheritedTeamName", "inheritedStartsOn", "inheritedEndsOn"
  ]
  static values = {
    teamGoals: Array,
    advisors: Array,
    isPersisted: Boolean
  }

  connect() {
    this.updateLayout()
  }

  updateLayout() {
    if (this.isPersistedValue) return

    const month = this.hasMonthTarget ? this.monthTarget.value : ""
    const year = this.hasYearTarget ? this.yearTarget.value : ""
    const userId = this.hasUserIdTarget ? this.userIdTarget.value : ""
    let teamId = this.hasTeamIdTarget ? this.teamIdTarget.value : ""

    if (userId && this.hasAdvisorsValue && this.advisorsValue.length > 0) {
      const adv = this.advisorsValue.find(a => a.id == userId)
      if (adv && adv.team_id) {
        teamId = adv.team_id
      }
    }

    // A team goal locks dates if a team goal exists for this effective team_id, month, and year
    let teamGoal = null
    if (teamId && month && year) {
      teamGoal = this.teamGoalsValue.find(g =>
        g.team_id == teamId && g.month == month && g.year == year
      )
    }

    const lockDates = !!teamGoal

    if (lockDates) {
      // Pre-fill dates
      if (teamGoal.starts_on && this.hasStartsOnTarget) this.startsOnTarget.value = teamGoal.starts_on
      if (teamGoal.ends_on && this.hasEndsOnTarget) this.endsOnTarget.value = teamGoal.ends_on

      // Display inheritance message
      if (this.hasInheritedTeamNameTarget && teamGoal.team_name) {
        this.inheritedTeamNameTarget.textContent = teamGoal.team_name
      }
      if (this.hasInheritedStartsOnTarget && teamGoal.starts_on) {
        this.inheritedStartsOnTarget.textContent = this.formatDate(teamGoal.starts_on)
      }
      if (this.hasInheritedEndsOnTarget && teamGoal.ends_on) {
        this.inheritedEndsOnTarget.textContent = this.formatDate(teamGoal.ends_on)
      }

      if (this.hasDateInputsContainerTarget) {
        this.dateInputsContainerTarget.classList.add("hidden")
      }
      if (this.hasInheritedMessageTarget) {
        this.inheritedMessageTarget.classList.remove("hidden")
      }
    } else {
      if (this.hasDateInputsContainerTarget) {
        this.dateInputsContainerTarget.classList.remove("hidden")
      }
      if (this.hasInheritedMessageTarget) {
        this.inheritedMessageTarget.classList.add("hidden")
      }
    }
  }

  formatDate(dateStr) {
    if (!dateStr) return ""
    const parts = dateStr.split("-")
    if (parts.length !== 3) return dateStr
    return `${parts[2]}/${parts[1]}/${parts[0]}` // DD/MM/YYYY
  }
}
